var React = require('react');

function CheckCircleIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z","strokeWidth":"1.5","key":0}),React.createElement("path",{"stroke":"none","className":"primary-fill","d":"M7.38771 12.25V6.33202H9.10371V12.25H7.38771ZM8.24571 5.50702C7.93038 5.50702 7.67371 5.41535 7.47571 5.23202C7.27771 5.04869 7.17871 4.82135 7.17871 4.55002C7.17871 4.27869 7.27771 4.05135 7.47571 3.86802C7.67371 3.68469 7.93038 3.59302 8.24571 3.59302C8.56105 3.59302 8.81771 3.68102 9.01571 3.85702C9.21371 4.02569 9.31271 4.24569 9.31271 4.51702C9.31271 4.80302 9.21371 5.04135 9.01571 5.23202C8.82505 5.41535 8.56838 5.50702 8.24571 5.50702Z","key":1})]);
}

CheckCircleIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckCircleIcon;

CheckCircleIcon.default = CheckCircleIcon;
